import apiHeader from '@/helpers/apiHeader';

const workflowService = {
    list(params) {
        return apiHeader.get('general-setting/workflow-approval/workflow', { params });
    },
    detail(id) {
        return apiHeader.get(`general-setting/workflow-approval/workflow/${id}`);
    },
    create(data) {
        return apiHeader.post('general-setting/workflow-approval/workflow', data);
    },
    update(id, data) {
        return apiHeader.patch(`general-setting/workflow-approval/workflow/${id}`, data);
    },
    delete(id) {
        return apiHeader.delete(`general-setting/workflow-approval/workflow/${id}`);
    },
    addCondition(conditionData) {
        return apiHeader.post('general-setting/workflow-approval/condition', conditionData);
    },
    editCondition(id, conditionData) {
        return apiHeader.patch(`general-setting/workflow-approval/condition/${id}`, conditionData);
    },
    removeCondition(id) {
        return apiHeader.delete(`general-setting/workflow-approval/condition/${id}`);
    },
    copyCondition(id) {
        return apiHeader.get(`general-setting/workflow-approval/condition/copy/${id}`);
    },
    diagramStepGet(params) {
        return apiHeader.get('general-setting/workflow-diagram', { params })
    },
    diagramStepDetail(id) {
        return apiHeader.get('general-setting/workflow-diagram/'+id)
    },
    diagramStepCreate(param) {
        return apiHeader.post('general-setting/workflow-diagram', param)
    },
    diagramStepUpdate(id, param) {
        return apiHeader.patch('general-setting/workflow-diagram/'+id, param)
    },
    diagramStepDelete(id) {
        return apiHeader.delete('general-setting/workflow-diagram/'+id)
    },
    diagramStepCopy(id, param) {
        return apiHeader.post('general-setting/workflow-diagram/copy/'+id, param)
    },
    paramUpdate(id, param) {
        return apiHeader.patch('general-setting/workflow-diagram/update-parameter/'+id, param)
    },
    diagramSave(id, param) {
        return apiHeader.patch('general-setting/workflow-diagram/save/'+id, param)
    },
    diagramView(code) {
        return apiHeader.get('general-setting/workflow-diagram/view/'+code)
    },
    workflowConfigStart(param) {
        return apiHeader.post('general-setting/workflow-config/start', param)
    },
    getScriptTemplates(params) {
        return apiHeader.get('general-setting/script-template', { params })
    }
}

export default workflowService;